import { CLASSES } from '@/scripts/helpers/constants/classes';
import { smoothScrollToTop } from '@/scripts/helpers/animation/smoothSctollTo';
import { EASING_FUNCTIONS } from '@/scripts/helpers/constants/easingFunctions';

const DOCUMENT_SCROLL_DURATION = 800;

function outerHeight(el) {
  let height = el.offsetHeight;
  const style = getComputedStyle(el);

  height += parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);
  return height;
}

document.addEventListener('DOMContentLoaded', () => {
  const { IS_VISIBLE } = CLASSES;
  const button = document.querySelector('.button-scroll-up');
  const bottomOffset = outerHeight(button);
  let lastScrollTop = 0;

  const handleUseButton = (e) => {
    e.preventDefault();
    smoothScrollToTop({
      duration: DOCUMENT_SCROLL_DURATION,
      easingFunction: EASING_FUNCTIONS.swing,
    });
  };

  button.addEventListener('click', handleUseButton);
  button.addEventListener('keyup', handleUseButton);

  window.addEventListener('scroll', function () {
    const currentScrollTop = this.pageYOffset;

    if (currentScrollTop <= lastScrollTop && currentScrollTop >= 200) {
      button.classList.add(IS_VISIBLE);
    } else {
      button.classList.remove(IS_VISIBLE);
    }

    lastScrollTop = currentScrollTop;

    if (window.scrollTop + window.innerHeight >= window.screen.height - bottomOffset) {
      button.classList.add(IS_VISIBLE);
    }
  });
});
